import Profile from "@/components/profile"
import { useAuthStore } from "@/store/auth"
import { Avatar, Button, Image, Popover, Row, Space } from "antd"
import React, { FC, useEffect, useState } from "react"

const UserMenuIcon = "/icons/user-menu.svg";
import { useTernaryDarkMode } from "usehooks-ts"
import "./index.less"
const ProfileButton: FC<{ avatar?: string }> = ({ avatar }) => {
  const { isDarkMode } = useTernaryDarkMode({ localStorageKey: "theme" })
  const user = useAuthStore(store => store.user)
  const [shortName, setShortName] = useState<string>("")

  useEffect(() => {
    if (user?.firstName && user?.lastName) {
      setShortName(getShortUsername())
    }
  }, [user])

  const getShortUsername = () => {
    const firstLetters = `${user?.firstName.charAt(0).toUpperCase()}${user?.lastName.charAt(0).toUpperCase()}`
    return firstLetters ?? ""
  }

  return (
    <Popover
      rootClassName={`${isDarkMode ? "dark" : "light"} profile-popover`}
      placement={"bottomRight"}
      trigger='click'
      content={<Profile />}
    >
      <Button className={"profile-button"}>
        {avatar ? (
          <Avatar style={{ verticalAlign: "middle" }} gap={1} src={avatar} />
        ) : (
          <Space>
            <Avatar
              className={"avatar-user-initials"}
              style={{ backgroundColor: "#1664FF", verticalAlign: "middle" }}
              gap={1}
            >
              {shortName}
            </Avatar>
          </Space>
        )}
        <Image src={UserMenuIcon} preview={false} rootClassName={"user-menu"} />
      </Button>
    </Popover>
  )
}

export default ProfileButton
